module.exports = {
  // 用户
  LoginJWTToken: "/Login/JWTToken3.0",  // 登录获取token
  GetInfoByToken: "/User/GetInfoByToken", // 获取用户信息
  GetNavigationBar: '/Permission/GetNavigationBar', // 获取路由数
  apiLoginLogOut: '/Login/LogOut', // 登出
  educationGet: '/education/Get', // 获取学历列表
  degreeGet: '/degree/Get', // 获取学位列表
  DeployDistrictGet: '/DeployDistrict/Get', // 地点联查
  PersonGetAllUsers: '/User/PersonGetAllUsers', // 用户获取个人权限
  PersonPostUserInfo: '/User/PersonPostUserInfo', // 个人更新用户信息
  identityresumePage: '/identityresume/Page', // 获取个人工作经历
  identityresumePost: '/identityresume/Post', // 添加工作经历
  identityresumePut: '/identityresume/Put', // 修改工作经历
  identityresumeDelete: '/identityresume/Delete', // 删除工作经历
  PicUploadToRemote: '/Img/UploadPictureToRemote', // 上传图片
  UserAuditPost: '/UserAudit/Post', // 用户申请加入企业
  QuitEnterprisePost: '/QuitEnterprise/Post', // 退出企业
  QuitEnterpriseQuery: '/QuitEnterprise/Query', // 查询退出企业记录
  UserAuditUserQuery: '/UserAudit/UserQuery', // 查询申请企业记录
  EnterpriseAuditSubmit: '/EnterpriseAudit/Submit', // 企业入驻
  EnterpriseAuditQueryState: '/EnterpriseAudit/QueryState', // 查询申请企业状态
  CourseUserQuery: '/Course/UserQuery', // 用户查询课程列表
  CourseHourGet: '/CourseHour/Get', // 获取课时详情
  AddUserFacePhoto: '/UserPhoto/AddUserFacePhoto', // 上传人脸底图
  UserPhotoUserAuth: '/UserPhoto/UserAuth', // 实名认证
  OwnCourseQuery: '/OwnCourse/OwnCourseQuery', // 查询我的课程列表
  OwnPlanQuery: '/OwnPlan/Query', // 查询我的计划
  OwnCourseOwnPlanCourseQuery: '/OwnCourse/OwnPlanCourseQuery', // 获取我的计划课程列表
  OwnQuestionBankQuery: '/OwnQuestionBank/Query', // 查询我的题库
  OwnSmlibraryQuery: '/OwnSmlibrary/Query', // 查询我的素材
  OwnPaperOwnPlanPaperQuery: '/OwnPaper/OwnPlanPaperQuery', // 查询我的计划试卷
  OwnPaperGetOwnPaperInfo: '/OwnPaper/GetOwnPaperInfo', // 获取计划试卷详情
  OwnPaperGetOwnPaperQuestion: '/OwnPaper/GetOwnPaperQuestion', // 获取模拟考核试卷题目
  OwnPaperGetOwnPaperDrillQuestion: '/OwnPaper/GetOwnPaperDrillQuestion', // 获取练习题目
  OwnPaperCommitPaper: '/OwnPaper/CommitPaper', // 提交试卷
  OwnCourseGetCourse: '/OwnCourse/GetCourse', // 获取课程详情
  OwnCollectPost: '/OwnCollect/Post', // 添加收藏
  OwnCollectDelete: '/OwnCollect/Delete', // 取消收藏
  GetValidateCode: '/User/GetValidateCode', // 获取验证码
  LoginPhoneLogin: '/Login/PhoneLogin', // 验证码注册登录
  CourseCollectQuery:'/OwnCollect/CourseCollectQuery',  //查询我的收藏列表
  GetOwnLibQuestion: '/OwnQuestionBank/GetOwnLibQuestion', // 获取我的题库题目
  DeleteErrorQuestion:'/ErrorQuestion/Delete' ,  //删除错题
  GetErrorQuestionDetailList:'/ErrorQuestion/GetErrorQuestionDetailList', //查询错题列表
  EvaluateQuery:'/Evaluate/Query',  //查询评价列表
  EvaluatePost:'/Evaluate/Post',   //添加评价
  OwnOrderQueryUserOrder:'/UserOrder/OwnOrderQuery', //查询用户订单
  GetOwnIntegral:'/OwnIntegral/Get',  //获取我的积分
  QueryIntegralOrigin:'/IntegralOrigin/Query',  //查询积分来源去向
  OwnQuestionBankQuery:'/OwnQuestionBank/Query', //用户获取题库列表
  QuestionLibCollectQuery:'/OwnCollect/QuestionLibCollectQuery', //查询题库列表
  QuestionLibraryUserQuery:'/QuestionLibrary/UserQuery', //用户查询题库列表
  GetQuestionLibrary:'/OwnQuestionBank/GetQuestionLibrary', //查询我的题库
  smlibraryUserGet:'/smlibrary/UserGet',   //用户查询资源库列表
  OwnSmlibraryGetSmlib:'/OwnSmlibrary/GetSmlib', //素材库详情
  WeChatPayQrCodePay:'/WeChatPay/QrCodePay', //微信扫码支付
  GetOrderState:'/PayBasics/GetOrderState',//订单状态查询
  GetOutTradeNoPage:'/PayBasics/GetOutTradeNoPage', //生成订单
  AlipayPcPay:'/Alipay/PcPay', //电脑网站
  OwnEveryDayTaskGetPaperInfo:'/OwnEveryDayTask/GetPaperInfo', //获取每日一练考题
  GetCourseSet: '/Course/GetCourseSet', // 获取课程设置详情
  IsLessonStudy: '/Study/IsLessonStudy', // 设置在学
  AddLesson: '/Study/AddLesson', // 添加课程进度
  GetCourseHourByid: '/Study/GetCourseHourByid', // 获取我的课时信息
  UserFaceAuth: '/UserPhoto/UserFaceAuth', // 人脸识别校验
  SmlibCollectQuery:'OwnCollect/SmlibCollectQuery', //查询素材库收藏列表
  CommitRightOrErrorRecode: '/OwnQuestionBank/CommitRightOrErrorRecode', // 提交答题记录
  GetTodayState: '/OwnEveryDayTask/GetTodayState', // 每日一练是否完成答题
  OwnEveryDayTaskCommitPaper: '/OwnEveryDayTask/CommitPaper', // 提交每日一练
  OwnEveryDayTaskQuery: '/OwnEveryDayTask/Query', // 获取每日一练记录
  OwnEveryDayTaskGet: '/OwnEveryDayTask/Get', // 获取每日一练详情
  GetMonthState: '/OwnEveryMonthTask/GetMonthState', // 每月一考是否完成答题
  OwnEveryMonthTaskGetPaperInfo: '/OwnEveryMonthTask/GetPaperInfo', // 获取每月一考考题
  OwnEveryMonthTaskCommitPaper: '/OwnEveryMonthTask/CommitPaper', // 每月一考提交
  OwnEveryMonthTaskQuery: '/OwnEveryMonthTask/Query', // 获取每月一考记录
  OwnEveryMonthTaskGet: '/OwnEveryMonthTask/Get', // 每月一考详情
  OwnEveryWeekTaskQuery: '/OwnEveryWeekTask/Query', // 每周一课历史课程
  FreeAddCourse: '/OwnCourse/FreeAddCourse', // 免费加入课程
  GetCourseHourList: '/OwnCourse/GetCourseHourList', // 获取课时列表
  OwnQuestionBankFreeAddCourse: '/OwnQuestionBank/FreeAddCourse', // 免费加入题库
  NewsGetNewsList: '/News/GetNewsList', // 获取新闻列表
  NoticeGetNewsList: '/Notice/GetNewsList', // 获取公告列表
  FreeAddSoftware: '/OwnSmlibrary/FreeAddSoftware', // 免费加入素材库
  UserGetSmfileList: '/OwnSmlibrary/UserGetSmfileList', // 素材库素材列表
  OwnEveryWeekTaskStartStudy: '/OwnEveryWeekTask/StartStudy', // 每周一课开始学习
  PlanGetPlanFaceConfig: '/Plan/GetPlanFaceConfig', // 获取计划人脸配置
  OwnQuestionBankSaveSchedule: '/OwnQuestionBank/SaveSchedule', // 保存练习进度
  GetSoftwareInfo:'/OwnSoftware/GetSoftwareInfo',//获取我的软件详情
  UpdateTaskProgross: '/OwnEveryWeekTask/UpdateTaskProgross', // 更新每周一课学习进度
  OwnPaperSaveSchedule: '/OwnPaper/SaveSchedule', // 保存计划练习答题进度
  CourseNoteQuery: '/CourseNote/Query', // 课程笔记查询
  CourseNotePost: '/CourseNote/Post', // 添加笔记
  CourseNoteDeleteNote: '/CourseNote/DeleteNote', // 删除笔记
  OwnPlanCoursePaperList: '/OwnCoursePaper/OwnPlanCoursePaperList', // 获取计划试卷列表
  OwnCoursePaperGetPracticeQuestion: '/OwnCoursePaper/GetPracticeQuestion', // 获取计划试卷练习题
  OwnCoursePaperSaveSchedule: '/OwnCoursePaper/SaveSchedule', // 保存练习进度
  OwnCoursePaperGetPaperQuestion: '/OwnCoursePaper/GetPaperQuestion', // 获取模拟获取考试题
  OwnCoursePaperCommitPaper: '/OwnCoursePaper/CommitPaper', // 提交试卷
  StatisticsGetMyData:'/Statistics/GetMyData',// 获取我的数据
  EmployInfoPageList: '/EmployInfo/EmployInfoPageList', // 查询招聘信息
  AddEmployInfo: '/EmployInfo/AddEmployInfo', // 增加招聘信息
  UpdateEmployInfo: '/EmployInfo/UpdateNew', // 修改招聘信息
  DeleteEmployInfo: '/EmployInfo/DeleteEmployInfo', // 删除招聘信息
  ResumeInfoPageList: '/EmployInfo/ResumeInfoPageList', // 投递信息查询
  AddResumeInfo: '/EmployInfo/AddResumeInfo', // 投递简历
  StaffActivityPageList: '/EmployInfo/StaffActivityPageList', // 查询员工活动
  AddStaffActivity: '/EmployInfo/AddStaffActivity', // 添加员工活动
  DeleteStaffActivity: '/EmployInfo/DeleteStaffActivity', // 删除员工活动
  DeleteResumeInfo: '/EmployInfo/DeleteResumeInfo', // 删除简历信息
  GetTrainClassify: '/TrainClassify/Query', // 查询培训类别
  TrainClassifyGetChildrenList: '/TrainClassify/GetChildrenList', // 查询二级类别
  GetPaperRecordList: '/OwnCoursePaper/GetPaperRecordList', // 获取答题记录
  GetPaperQuestionRecord: '/OwnCoursePaper/GetPaperQuestionRecord', // 获取试卷详情
  // 管理
  GetTreeTable: '/Permission/GetTreeTable', // 获取菜单表格
  GetPermissionTree: '/Permission/GetPermissionTree', // 获取菜单树
  GetApiList: '/Module/Get', // 获取全部API接口
  PermissionPost: '/Permission/Post', // 添加菜单
  PermissionPut: '/Permission/Put', // 更新菜单
  PermissionDelete: '/Permission/Delete', // 删除菜单
  ModuleGet: '/Module/Get', // 获取全部接口
  ModulePost: '/Module/Post', // 添加接口
  ModulePut: '/Module/Put', // 更新接口
  ModuleDelete: '/Module/Delete', // 删除接口
  RoleGet: '/Role/Get', // 获取全部角色
  RolePost: '/Role/Post', // 添加角色
  RolePut: '/Role/Put', // 编辑角色
  RoleDelete: '/Role/Delete', // 删除角色
  GetPermissionIdByRoleId: '/Permission/GetPermissionIdByRoleId', // 通过角色获取菜单
  PermissionAssign: '/Permission/Assign', // 保存菜单权限分配
  GetRootNavigationBar: '/Permission/GetRootNavigationBar', // 获取顶部菜单（一级路由）
  GetNavigationBarByPid: '/Permission/GetNavigationBarByPid', // 通过ID回去路由树
  MonitorQuery:'/Monitor/Query', //查询日志
  OnlineQuery: '/Online/Query', // 查询在线用户
  OnlineDelete: '/Online/Delete', // 踢出在线用户
  GetTaskNameSpace: '/TasksQz/GetTaskNameSpace', // 获取任务命名空间
  TasksQzPost: '/TasksQz/Post', // 添加计划任务
  TasksQzGet: '/TasksQz/Get', // 获取计划任务
  TasksQzPut: '/TasksQz/Put', // 修改计划任务
  TasksQzStartJob: '/TasksQz/StartJob', // 启动计划任务
  TasksQzStopJob: '/TasksQz/StopJob', // 停止任务
  TasksQzDelete: '/TasksQz/Delete', // 删除任务
  SensitiveWordsQueryBlackIp: '/SensitiveWords/QueryBlackIp', // 获取敏感词
  AddSensitiveWords: '/SensitiveWords/AddSensitiveWords', // 添加敏感词
  UpdateSensitiveWords: '/SensitiveWords/UpdateSensitiveWords', // 修改敏感词
  DeleteSensitiveWords: '/SensitiveWords/DeleteSensitiveWords', // 删除敏感词
  QueryBlackIp: '/SysIp/QueryBlackIp', // 查询黑名单
  AddBlackIp: '/SysIp/AddBlackIp', // 添加黑名单
  UpdateBlackIp: '/SysIp/UpdateBlackIp', // 修改黑名单
  DeleteBlackIp: '/SysIp/DeleteBlackIp', // 删除黑名单
  CClassifyQuery: '/CClassify/Query', // 获取课程类型
  CClassifyControlState: '/CClassify/ControlState', // 课程类型开放/禁用
  CClassifyPost: '/CClassify/Post', // 添加课程类型
  CClassifyPut: '/CClassify/Put', // 修改课程类型
  CClassifyDelete: '/CClassify/Delete', // 删除课程类型
  CSSubjectQuery: '/CSSubject/Query', // 获取课程专题
  CSSubjectControlState: '/CSSubject/ControlState', // 课程专题状态修改
  CSSubjectPost: '/CSSubject/Post', // 添加课程专题
  CSSubjectPut: '/CSSubject/Put', // 修改课程专题
  CSSubjectDelete: '/CSSubject/Delete', // 删除课程专题 行业领域
  IndustryClassifyQuery: '/IndustryClassify/Query', // 获取行业领域
  IndustryClassifyControlState: '/IndustryClassify/ControlState', // 行业领域状态修改
  IndustryClassifyPost: '/IndustryClassify/Post', // 添加行业领域
  IndustryClassifyPut: '/IndustryClassify/Put', // 修改行业领域
  IndustryClassifyDelete: '/IndustryClassify/Delete', // 删除行业领域
  UserGetAddmin:'/User/GetAddmin',       //获取添加管理员
  UserPostAdmin:'/User/PostAdmin',       //添加管理员
  UserPut:'/User/Put' ,            //修改管理员信息
  UserDelete:'/User/Delete' ,        //删除管理员
  SuperGetAllUsers:'/User/SuperGetAllUsers',  //超级管理员获取用户信息
  UpdatePwd:'/User/UpdatePwd', //重置管理员密码
  GetEnterprise:'/Enterprise/Get', //获取企业信息
  DeleteEnterprise:'/Enterprise/Delete'  ,   //删除企业信息
  PutEnterprise:'Enterprise/Put',  //修改企业信息
  QueryInstitution:'/Enterprise/Query',  //查询机构企业信息image.png
  SMClassifyQuery: '/SMClassify/Query', // 获取素材类型
  ConstrolState:'/Enterprise/ConstrolState',   //企业类型状态修改
  SMClassifyControlState: '/SMClassify/ControlState', // 素材类型状态修改
  SMClassifyPost: '/SMClassify/Post', // 添加素材类型
  SMClassifyPut: '/SMClassify/Put', // 修改素材类型
  SMClassifyDelete: '/SMClassify/Delete', // 删除素材类型
  QuestionClassifyQuery: '/QuestionClassify/Query', // 获取试题类别
  QuestionClassifyControlState: '/QuestionClassify/ControlState', // 试题类别状态修改
  QuestionClassifyPost: '/QuestionClassify/Post', // 添加试题类别
  QuestionClassifyPut: '/QuestionClassify/Put', // 修改试题类别
  QuestionClassifyDelete: '/QuestionClassify/Delete', // 删除试题类别
  PaperClassifyQuery: '/PaperClassify/Query', // 获取试卷类别
  PaperClassifyControlState: '/PaperClassify/ControlState', // 试卷类别状态修改
  PaperClassifyPost: '/PaperClassify/Post', // 添加试卷类别
  PaperClassifyPut: '/PaperClassify/Put', // 修改试卷类别
  PaperClassifyDelete: '/PaperClassify/Delete', // 删除试卷类别
  PlanClassifyQuery: '/PlanClassify/Query', // 获取计划类别
  PlanClassifyControlState: '/PlanClassify/ControlState', // 计划类别状态修改
  PlanClassifyPost: '/PlanClassify/Post', // 添加计划类别
  PlanClassifyPut: '/PlanClassify/Put', // 修改计划类别
  PlanClassifyDelete: '/PlanClassify/Delete', // 删除计划类别
  EntepriseClassifyQuery: '/EntepriseClassify/Query', // 获取企业类别
  EntepriseClassifyControlState: '/EntepriseClassify/ControlState', // 企业类别状态修改
  EntepriseClassifyPost: '/EntepriseClassify/Post', // 添加企业类别
  EntepriseClassifyPut: '/EntepriseClassify/Put', // 修改企业类别
  EntepriseClassifyDelete: '/EntepriseClassify/Delete', // 删除企业类别
  TrainClassifyQuery: '/TrainClassify/Query', // 获取培训类别（树结构）
  TrainClassifyPost: '/TrainClassify/Post', // 添加培训类别
  TrainClassifyPut: '/TrainClassify/Put', // 修改培训类别
  TrainClassifyDelete: '/TrainClassify/Delete', // 删除培训类别
  DepartmentGetTreeTable: '/Department/GetTreeTable', // 获取组织架构
  DepartmentPost: '/Department/Post', // 添加部门
  DepartmentPut: '/Department/Put', // 修改部门
  DepartmentDelete: '/Department/Delete', // 删除部门
  AppointmentQuery: '/Appointment/Query', // 获取岗位
  AppointmentPost: '/Appointment/Post', // 添加岗位
  AppointmentPut: '/Appointment/Put', // 修改岗位
  AppointmentDelete: '/Appointment/Delete', // 删除岗位
  EntGetAllUsers: '/User/EntGetAllUsers', // 企业获取用户列表
  GetDepartmentTree: '/Department/GetDepartmentTree', // 获取部门树
  UserPost: '/User/Post', // 管理员添加用户
  EntPostUserInfo: '/User/EntPostUserInfo', // 管理员更新用户信息
  AdminGetUserCourseQuery:'/OwnCourse/AdminGetUserCourseQuery', //管理员获取用户课程
  IntegralOriginAdminQuery:'/IntegralOrigin/AdminQuery' ,//管理员查询用户积分
  AdminCollectQuery:'/OwnCollect/AdminCollectQuery', //管理员查询用户收藏
  smlibraryGet: '/smlibrary/Get', // 获取素材库
  smlibraryGetById: '/smlibrary/Get', // 获取素材库
  smlibraryPost: '/smlibrary/Post', // 创建素材库
  smlibraryPublishState:'/smlibrary/PublishState', //素材库切换发布状态
  smlibraryPut: '/smlibrary/Put', // 修改素材库
  smlibraryDelete: '/smlibrary/Delete', // 删除素材库
  UserAuditAdminQuery: '/UserAudit/AdminQuery', // 获取学员审核列表
  UserAuditAudit: '/UserAudit/Audit', // 审核
  EnterpriseAuditQuery: '/EnterpriseAudit/Query', // 企业申请列表
  EnterpriseAuditAudit: '/EnterpriseAudit/Audit', // 审核企业
  smfilepackEntGet: '/smfilepack/EntGet', // 企业管理查询素材
  ExportUserTemplate: '/ExcelTemplate/ExportUserTemplate', // 下载用户导入模板
  UploadUsers: '/User/UploadUsers', // 批量添加用户
  TYYCreatVideo: '/TYYVideo/CreatVideo', // 天翼云上传创建视频
  CreatTransCodeTask: '/TYYVideo/CreatTransCodeTask', // 天翼云创建转码任务
  GetTransCodeVideoUrl: '/TYYVideo/GetTransCodeVideoUrl', // 获取转码后地址
  queryTaskProcess: '/TYYVideo/queryTaskProcess', // 获取转码进度
  GetS3TaskProcess: '/TYYVideo/GetS3TaskProcess/GetS3TaskProcess', // 获取进度
  smfilepackPost: '/smfilepack/Post', // 添加素材
  smfilepackDelete: '/smfilepack/Delete', // 删除素材
  smfilepackPut: '/smfilepack/Put', // 编辑素材
  UploadFileToRemote: '/Img/UploadFileToRemote', // 上传文档文件
  QuestionLibraryPost: '/QuestionLibrary/Post', // 创建题库
  QuestionLibraryQuery: '/QuestionLibrary/Query', // 获取题库列表
  QuestionLibraryChangePublishState: '/QuestionLibrary/ChangePublishState', // 切换题库发布状态
  QuestionLibraryPut: '/QuestionLibrary/Put', // 修改题库
  QuestionLibraryDelete: '/QuestionLibrary/Delete', // 删除题库
  QuestionLibraryGet: '/QuestionLibrary/Get', // 获取题库信息
  SetLibPaperSet: '/QuestionLibrary/SetLibPaperSet', // 设置题库试卷
  GetLibPaperSet: '/QuestionLibrary/GetLibPaperSet', // 获取试卷设置
  QuestionQuery: '/Question/Query', // 获取试题列表
  QuestionPost: '/Question/Post', // 添加试题
  ExportQuestionTemplate: '/ExcelTemplate/ExportQuestionTemplate', // 试题导入模板
  UploadQuestion: '/Question/UploadQuestion', // 批量上传试题
  QuestionPut: '/Question/Put', // 修改试题
  QuestionDelete: '/Question/Delete', // 删除试题
  DelLibraryAllQuestion: '/Question/DelLibraryAllQuestion', // 清空题库试题
  QuestionGet: '/Question/Get', // 获取试题详情
  PaperQuery: '/Paper/Query', // 查询试卷
  PaperPost: '/Paper/Post', // 创建试卷
  PaperGet: '/Paper/Get', // 获取试卷详情
  PaperPut: '/Paper/Put', // 试卷修改
  PaperDelete: '/Paper/Delete', // 删除试卷
  PaperUpdatePublishState: '/Paper/UpdatePublishState', // 更新试卷发布状态
  RandomAddQuestions: '/PaperQuestion/RandomAddQuestions', // 随机添加试题
  PaperQuestionQuery: '/PaperQuestion/Query', // 查询已添加试题
  BatchAddQuestions: '/PaperQuestion/BatchAddQuestions', // 手动批量添加试题
  PaperQuestionDelete: '/PaperQuestion/Delete', // 删除已选试题
  PaperAddLibrary: '/Paper/AddLibrary', // 添加练习到试卷
  CoursePost: '/Course/Post', // 创建课程
  CourseQuery: '/Course/Query', // 查询课程列表
  CourseDelete: '/Course/Delete', // 课程删除
  CourseUpdatePublishState: '/Course/UpdatePublishState', // 切换发布状态
  CourseGet: '/Course/Get', // 获取课程详情
  CoursePut: '/Course/Put', // 修改课程信息
  CatalogueGet: '/Catalogue/Get', // 获取课程目录
  CatalogueQueryTree: '/Catalogue/QueryTree', // 获取目录树形
  GetCourseCatalogue: '/OwnCourse/GetCourseCatalogue', // 获取课程目录
  CataloguePost: '/Catalogue/Post', // 添加章节
  CataloguePut: '/Catalogue/Put', // 编辑章节
  CatalogueDelete: '/Catalogue/Delete', // 章节删除
  CourseHourBatchAdd: '/CourseHour/BatchAdd', // 批量添加课时
  smfilepackCourseGet: '/smfilepack/CourseGet', // 课程查询素材
  smlibraryAdminGet: '/smlibrary/AdminGet', // 企业管理员查询素材库
  CourseHourDelete: '/CourseHour/Delete', // 删除目录
  CourseFilePost: '/CourseFile/Post', // 添加课件和扩展阅读
  CourseFileQuery: '/CourseFile/Query', // 课件和扩展阅读查询
  CourseFilePut: '/CourseFile/Put', // 课件和扩展阅读修改
  CourseFileDelete: '/CourseFile/Delete', // 删除课件和扩展阅读
  PlanPost: '/Plan/Post', // 创建培训计划
  PlanQuery: '/Plan/Query', // 查询企业计划
  GetPlanUserList: '/Plan/GetPlanUserList', // 获取计划学员列表
  GetPlanUserListNoCheck: '/Plan/GetPlanUserListNoCheck', // 获取计划未勾选学员
  PlanBatchAddUser: '/Plan/BatchAddUser', // 计划批量添加学员
  PlanGet: '/Plan/Get', // 获取计划详情
  PlanDelete: '/Plan/Delete', // 删除计划
  PlanPut: '/Plan/Put', // 修改培训计划
  CopyPlan: '/Plan/CopyPlan', // 复制计划
  GetCourseListNoCheck: '/PlanAndCourse/GetCourseListNoCheck', // 获取计划未勾选课程
  PlanAndCourseAddCourseList: '/PlanAndCourse/AddCourseList', // 计划添加课程
  PlanAndCourseQueryCourseList: '/PlanAndCourse/QueryCourseList', // 获取计划课程列表
  PlanAndCoursePagerUserQuery: '/PlanAndCourse/PagerUserQuery', // 计划课程查询用户进度
  PlanAndCourseDelete: '/PlanAndCourse/Delete', // 删除计划课程
  PlanChangePublishState: '/Plan/ChangePublishState', // 切换计划发布状态
  PlanAndPaperQueryCourseList: '/PlanAndPaper/QueryCourseList', // 获取计划内的试卷列表
  PlanAndPaperPagerUserQuery: '/PlanAndPaper/PagerUserQuery', // 计划试卷查询用户进度
  PlanAndPaperGetPaperListNoCheck: '/PlanAndPaper/GetPaperListNoCheck', // 获取未勾选试卷列表
  PlanAndPaperAddCourseList: '/PlanAndPaper/AddCourseList', // 计划添加试卷
  PlanAndPaperDelete: '/PlanAndPaper/Delete', // 删除试卷
  OperateQuery:'/QuestionLibrary/OperateQuery',  //运营查询题库列表
  PostAuthQuestionBank:'/AuthQuestionBank/Post' ,  //平台运营添加授权
  GetUserList:'/AuthQuestionBank/GetUserList',   //获取授权人
  GetEnterpriseList:'/AuthCourse/GetEnterpriseList' ,   //获取企业
  CourseOperateQuery: '/Course/OperateQuery', // 运营查询课程
  AuthCourseGetUserList: '/AuthCourse/GetUserList', // 课程查询可授权的人
  AuthCourseGetEnterpriseList: '/AuthCourse/GetEnterpriseList', // 课程查询可授权企业
  AuthCoursePost: '/AuthCourse/Post', // 课程运营授权
  GetUserPhotoData:'/UserPhoto/GetUserPhotoData', //管理员获取用户身份证照片
  smlibraryOperateGet: '/smlibrary/OperateGet', // 运营查询素材库
  AuthSmlibraryGetUserList: '/AuthSmlibrary/GetUserList', // 素材库查询可授权的人
  AuthSmlibraryGetEnterpriseList: '/AuthSmlibrary/GetEnterpriseList', // 素材库查询可授权企业
  AuthSmlibraryPost: '/AuthSmlibrary/Post', // 素材库运营授权
  CourseOperateUpdateOnlineState: '/Course/OperateUpdateOnlineState', // 平台运营课程上下架
  CourseOperateRecommendState: '/Course/OperateRecommendState', // 运营课程推荐
  CourseOperateBoutiqueState: '/Course/OperateBoutiqueState', // 运营精品课程
  BankOnlineState:'/QuestionLibrary/OnlineState',   //平台运营题库上下架
  SmlibraryOnSmLib: '/smlibrary/OnSmLib', // 素材库上下架
  smlibrarySetBoutiqueState: '/smlibrary/SetBoutiqueState', // 素材库设置精选
  smlibrarySetRecommendState: '/smlibrary/SetRecommendState', // 素材库推荐
  AdminOrderQuery:'/UserOrder/AdminOrderQuery',  //订单查询
  EveryDayTaskQuery: '/EveryDayTask/Query', // 获取每日一练
  EveryDayTaskPost: '/EveryDayTask/Post', // 添加每日一练
  EveryDayTaskPut: '/EveryDayTask/Put', // 修改每日一练
  EveryDayTaskDelete: '/EveryDayTask/Delete', // 删除每日一练
  EveryWeekTaskPost: '/EveryWeekTask/Post', // 添加每周一课
  EveryWeekTaskQuery: '/EveryWeekTask/Query', // 获取每周一课
  EveryWeekTaskPut: '/EveryWeekTask/Put', // 修改每周一课
  EveryWeekTaskDelete: '/EveryWeekTask/Delete', // 删除每周一课
  EveryMonthTaskQuery: '/EveryMonthTask/Query', // 获取每月一考
  EveryMonthTaskPost: '/EveryMonthTask/Post', // 添加每月一考
  EveryMonthTaskPut: '/EveryMonthTask/Put', // 修改每月一考
  EveryMonthTaskDelete: '/EveryMonthTask/Delete', // 删除每月一考
  PhysicalSpaceQuery: '/PhysicalSpace/Query', // 查询物理空间
  PhysicalSpacePost: '/PhysicalSpace/Post', // 添加物理空间
  PhysicalSpacePut: '/PhysicalSpace/Put', // 修改物理空间
  PhysicalSpaceDelete: '/PhysicalSpace/Delete', // 删除物理空间
  QueryAllRegion: '/PhyRegion/QueryAllRegion', // 获取区域、设备列表
  PhyRegionGetAllCamera: '/PhyRegion/GetAllCamera', // 获取摄像头列表
  PhysicalSpaceGetPhysicsLogin: '/PhysicalSpace/GetPhysicsLogin', // 查询登录记录
  PhyRegionPost: '/PhyRegion/Post', // 添加区域
  PhyRegionPut: '/PhyRegion/Put', // 修改区域
  PhyRegionDelete: '/PhyRegion/Delete', // 删除区域
  GetNoUseRegionList: '/PlanPhyRegion/GetNoUseRegionList', // 计划查询可添加区域
  PlanPhyRegionPost: '/PlanPhyRegion/Post', // 计划添加区域
  PlanPhyRegionQuery: '/PlanPhyRegion/Query', // 查询计划内区域列表
  PlanPhyRegionDelete: '/PlanPhyRegion/Delete', // 删除计划内区域
  GetNoUseDeivceList: '/PlanPhyDevice/GetNoUseDeivceList', // 获取计划内可添加的设备
  PlanPhyDeviceQuery: '/PlanPhyDevice/Query', // 查询计划设备列表
  PlanPhyDevicePost: '/PlanPhyDevice/Post', // 计划区域添加设备
  PlanPhyDeviceDelete: '/PlanPhyDevice/Delete', // 删除区域设备
  SoftwareQuery:'/Software/Query', //管理员查询软件
  SoftwarePost:'/Software/Post', //管理员添加软件
  SoftwarePut:'/Software/Put', //管理员修改软件
  SoftwareDelete:'/Software/Delete', //管理员删除软件
  SoftwareGet:'/Software/Get', //管理员获取软件详情
  workingconditionQuery: '/workingcondition/Query', // 查询软件工况列表
  workingconditionPost: '/workingcondition/Post', // 添加工况
  workingconditionPut: '/workingcondition/Put', // 修改工况
  workingconditionDelete: '/workingcondition/Delete', // 删除工况
  SoftwarePublishState:'/Software/PublishState',  //修改软件发布状态
  SoftwareOnlineState:'/Software/OnlineState',  //管理员查询软件上下架状态
  SoftwareOperateQuery:'/Software/OperateQuery', //运营查询软件
  SoftwareOperateBoutiqueState:'/Software/OperateBoutiqueState', //运营更新精品状态
  SoftwareOperateRecommendState:'/Software/OperateRecommendState', //运营更新推荐状态
  AuthSoftwarePost:'/AuthSoftware/Post',//运营软件授权
  NewsQuery: '/News/Query', // 查询新闻列表
  NewsChangePublishState: '/News/ChangePublishState', // 修改新闻发布状态
  NewsChangeTopState: '/News/ChangeTopState', // 修改新闻置顶状态
  NewsPost: '/News/Post', // 添加新闻
  NewsPut: '/News/Put', // 修改新闻
  NewsDelete: '/News/Delete', // 删除新闻
  NoticeQuery: '/Notice/Query', // 查询公告
  NoticePost: '/Notice/Post', // 添加公告
  NoticePut: '/Notice/Put', // 修改公告
  NoticeDelete: '/Notice/Delete', // 删除公告
  NoticeChangePublishState: '/Notice/ChangePublishState', // 修改公告发布状态
  AuthSoftwareGetEnterpriseList:'/AuthSoftware/GetEnterpriseList', //获取软件授权企业
  AuthSoftwareGetUserList:'/AuthSoftware/GetUserList', //软件获取个人授权
  ImgSoftwareUpload:'/api/Img/SoftwareUpload', // 软件切片上传
  AdvertisementQuery:'/Advertisement/Query', //查询公告管理
  QuestionLibrarySetBoutiqueState:'/QuestionLibrary/SetBoutiqueState',//题库设置精品
  QuestionLibrarySetRecommendState:'/QuestionLibrary/SetRecommendState', //题库设置推荐
  NoticePost:'/Notice/Post', //添加公告
  LecturerQuery:'/Lecturer/Query', //培训讲师
  LecturerGet:'/Lecturer/Get',//培训讲师详情
  LecturerPost:'/Lecturer/Post', //培训讲师添加
  LecturerDelete:'/Lecturer/Delete', //培训讲师删除
  LecturerPut:'/Lecturer/Put',// 培训讲师修改
  UserAdminGetRoleUser:'/User/AdminGetRoleUser',//按角色查询用户
  PlanUploadUsers: '/Plan/UploadUsers', // 计划批量导入用户
  EnterpriseQueryAll:'/Enterprise/QueryAll', //查询所以企业列表
  UserSuperPostUser:'/User/SuperPostUser', //总管理员添加普通用户
  UserSuperPostEnterpriseUser:'/User/SuperPostEnterpriseUser',//总管理员添加企业用户
  GetPlanCourseChList: '/PlanAndCourse/GetPlanCourseChList', // 获取计划课程课时
  LecturerQueryAll:'/Lecturer/QueryAll', //获取讲师列表
  UpdatePlanCourse: '/PlanAndCourse/UpdatePlanCourse', // 更新计划课程学时
  LecturerGetLecturer:'/Lecturer/GetLecturer', //获取教师列表
  UserGetSoftwareList:'/Software/UserGetSoftwareList', //用户获取软件
  StartSoftwareServer: '/Study/StartSoftwareServer', // 启动软件
  EntChangeTeacherRole:'/User/EntChangeTeacherRole', //管理员修改教师角色
  OwnPlanAdminQuery:'/OwnPlan/AdminQuery' ,//管理员获取用户计划列表
  PlanGetExportPlanData: '/Plan/GetExportPlanData', // 获取计划学员进度
  GetCCStatistics:'/Statistics/GetCCStatistics' ,//获取资格类型统计
  GetPlantatistics:'/Statistics/GetPlantatistics' , //获取计划列表统计
  GetTrainTypeStatistics:'/Statistics/GetTrainTypeStatistics', //获取培训类型统计
  GetUserMonthAddedStatistics:'/Statistics/GetUserMonthAddedStatistics', //获取用户每月新增学员
  GetUserStatistics:'/Statistics/GetUserStatistics', //获取用户统计
  UserAdminUpdateUserPwd:'/User/AdminUpdateUserPwd',  //管理员更新用户密码
  PlanDelPlanUser: '/Plan/DelPlanUser', // 删除计划人员
  StatisticsGetUserStatistics: '/Statistics/GetUserStatistics', // 获取企业用户统计
  StatisticsGetUserMonthAddedStatistics: '/Statistics/GetUserMonthAddedStatistics', // 获取每月新增学员
  StatisticsGetTrainTypeStatistics: '/Statistics/GetTrainTypeStatistics', // 获取培训类型统计
  StatisticsGetCCStatistics: '/Statistics/GetCCStatistics', // 获取资格类型统计
  StatisticsGetPlantatistics: '/Statistics/GetPlantatistics', // 计划统计列表
  DepartmentDepartmentImportUsers: '/Department/DepartmentImportUsers', // 部门批量导入学员
  ExportCatalogueTemplate: '/ExcelTemplate/ExportCatalogueTemplate', // 获取章节模板
  CatalogueImportCatalogue: '/Catalogue/ImportCatalogue', // 批量导入章节
  IndustryClassifyGetListByCsId: '/IndustryClassify/GetListByCsId', // 根据行业领域获取课程专题
  PaperQueryAll: '/Paper/QueryAll', // 查询已发布试卷列表
  QuestionLibraryQueryAll: '/QuestionLibrary/QueryAll', // 查询已发布题库
  GetPlanPaperRecordList:'/Plan/GetPlanPaperRecordList' , // 管理员获取计划模拟记录
  GetPlanUserProve: '/Plan/GetPlanUserProve', // 生成学员学时证明
  StatisticsGetOfflinePhySpaceData:'/Statistics/GetOfflinePhySpaceData', //大数据线下物理空间
  StatisticsGetEnterpriseStatisData:'/Statistics/GetEnterpriseStatisData' ,//大数据获取企业基础信息
  PushPlanToTrainPlatfom: '/TrainPlatform/PushPlanToTrainPlatfom', // 推送计划至培训平台
};
